import { useProviderDetailStore } from "../../store/provider-details/providerDetailStore";

import ProviderAdditionalContactsDisplayView from "./ProviderAddionalContactsDisplayView";

export default function ProviderAdditionalPhonesDisplayView({ data }) {
  const { additionalPhoneTypes } = useProviderDetailStore();

  return (
    <ProviderAdditionalContactsDisplayView
      dataMap={data?.contactInfos ?? {}}
      typesMap={additionalPhoneTypes}
      valueKey="display"
      typeKey="contactLabel"
      labelSuffix="Phone Number"
    />
  );
}
